import React, { useState, useRef, useEffect } from "react";

import { toSafeFilename } from "../../../helpers";
import FilePlus from "../../../utils/icons/FilePlus";

export default function OpAudioAndPhotoToVide({
  valid,
  labelButton,
  message,
  onSubmit,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  onSubmit: Function;
}) {
  const [newFilename, setNewFilename] = useState(null);
  const [soundWave, setSoundWaveFlag] = useState(true);
  const filenameInput = useRef(null);

  useEffect(() => {
    if (valid) {
      setTimeout(() => {
        filenameInput.current.focus();
      }, 50);
    }
  }, [valid]);

  return valid ? (
    <div style={{ maxWidth: "350px", margin: "0 auto" }}>
      <div className="center">↓</div>
      <input
        key="input"
        type="text"
        className="block fz08 mt1"
        name="filename"
        placeholder="Enter a filename"
        onChange={(e) => setNewFilename(e.target.value)}
        ref={filenameInput}
      />
      <div className="fz08">
        <button
          className={
            "reset as-link with-icon tal block mb03 " +
            (soundWave ? "activated" : "deactivated")
          }
          onClick={() => setSoundWaveFlag(!soundWave)}
        >
          {soundWave
            ? "Sound wave overlay enabled"
            : "Sound wave overlay disabled"}
        </button>
        <small>
          {soundWave
            ? "Disable this option if you don't want to have a sound wave animation on top of your image."
            : "Enable this option if you want to have a sound wave animation on top of your image."}
        </small>
      </div>
      <div className="center mt1">
        <button
          className="secondary"
          disabled={!newFilename}
          onClick={() =>
            onSubmit({
              filename: toSafeFilename(newFilename),
              soundWave,
            })
          }
        >
          {labelButton}
        </button>
      </div>
    </div>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}
